module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-dis-cae39e38fe31ae794a43bf3fc61b76cf.png";